webpackJsonp([24],{

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_share_vue__ = __webpack_require__(341);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28bf1643_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_share_vue__ = __webpack_require__(473);
function injectStyle (ssrContext) {
  __webpack_require__(465)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28bf1643"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_share_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28bf1643_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_share_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Content__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nm_node_snackbar_dist_snackbar_css__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_nm_node_snackbar_dist_snackbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_nm_node_snackbar_dist_snackbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_clipboard__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Share",
  props: ["content", "color"],
  data: function data() {
    return {
      showPopup: false,
      twitterShareUrl: undefined,
      gplusShareUrl: undefined,
      link: null,
      clipboard: undefined,
      imgUrl: __webpack_require__(471)
    };
  },
  created: function created() {
    this.createLink();
    this.initShare();
    if (this.color === "BLACK") {
      this.imgUrl = __webpack_require__(472);
    }
  },

  watch: {
    content: function content() {
      this.createLink();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clipboard.destroy();
  },

  methods: {
    shareCount: function shareCount(medium) {
      // console.log("medium&Content", this.content, medium);
      this.vLiveSDKContentShare(this.content, medium);
    },
    createLink: function createLink() {
      if (this.clipboard) {
        this.clipboard.destroy();
      }

      var hostname = window.location.host;

      if (hostname.includes('www.')) {
        hostname = hostname.replace('www.', '');
      }

      // console.log('hostname===', hostname)

      // this.link = `https://${window.location.host}/content?contentid=${this.content.contentid}`;
      this.link = "https://" + hostname + "/content?contentid=" + this.content.contentid;
      this.clipboard = new __WEBPACK_IMPORTED_MODULE_4_clipboard___default.a(".custom-link");
      this.clipboard.on("success", function (e) {
        // console.info("Action:", e.action);
        // console.info("Text:", e.text);
        // console.info("Trigger:", e.trigger);
        // Show the snackbar message
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({ text: "Link Generated", pos: "bottom-center" });
        e.clearSelection();
      });
      this.clipboard.on("error", function (e) {
        console.error("Action:", e.action);
        console.error("Trigger:", e.trigger);
      });
    },
    initShare: function initShare() {
      // console.log('[Share initShare content]', this.content);

      if (!this.content) return;
      // Creating the twitter share URL
      this.twitterShareUrl = "https://twitter.com/share?url=" + encodeURIComponent(window.location.href);
      // let image = this.getPoster(this.content);
      // this.twitterShareUrl = 'https://twitter.com/share?'+'text=Watch ' + this.content.title + ' on SDG'+'&url=' + image;
      // console.log("twitter>>",image)
      // console.log("url>>", this.twitterShareUrl);
      // Creating the Google Plus share URL
      this.gplusShareUrl = "https://plus.google.com/share?url=" + encodeURIComponent(window.location.href);
    },
    togglePopup: function togglePopup(state) {
      this.showPopup = state;
    },
    getPoster: function getPoster(content) {
      if (content.posters.length) {
        var landscapeposters = content.posters.filter(function (pos) {
          return pos.orientation === "PORTRAIT";
        });
        if (landscapeposters.length) {
          var posterIndex = landscapeposters.findIndex(function (pos) {
            return pos.quality === "HD";
          });
          if (posterIndex > -1) {
            return landscapeposters[posterIndex].url;
          } else {
            return landscapeposters[0].url;
          }
        }
      }
    },
    shareFbCB: function shareFbCB() {
      this.vLiveSDKContentShare(this.content, "FACEBOOK");
      // Get the URL to be shared
      var link = window.location.href;
      // Get the image to be shown on the feed
      var image = this.getPoster(this.content);
      // Get the title to be shown on the feed
      var title = "Watch " + this.content.title + " on SDG";
      // Get the description to be shown on the feed
      var description = this.content.description;

      // Initialize Share
      FB.ui({
        method: "share_open_graph",
        action_type: "og.shares",
        action_properties: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          object: {
            "og:url": window.location.href,
            "og:title": title,
            "og:description": description,
            "og:image": image
          }
        })
      }, function (response) {
        // console.log('[shareFbCB response]', response);
      });
    },
    shareGpCB: function shareGpCB() {
      // console.log('[shareGpCB]');
    },
    shareTwCB: function shareTwCB() {
      this.vLiveSDKContentShare(this.content, "TWITTER");
      var image = this.getPoster(this.content);
      //        <meta name="twitter:card" content="summary" />
      // <meta name="twitter:site" content="@flickr" />
      // <meta name="twitter:title" content="Small Island Developing States Photo Submission" />
      // <meta name="twitter:description" content="View the album on Flickr." />
      // <meta name="twitter:image" content="https://farm6.staticflickr.com/5510/14338202952_93595258ff_z.jpg" />
      var linkTag = document.getElementsByTagName("link")[0];
      var summary = "";
      summary = document.createElement("meta");
      summary.name = "twitter:card";
      summary.content = "summary";
      document.head.insertBefore(summary, linkTag);

      var twttrSite = "";
      twttrSite = document.createElement("meta");
      twttrSite.name = "twitter:site";
      twttrSite.content = "@SDG";
      document.head.insertBefore(twttrSite, linkTag);

      var ogUrl = "";
      ogUrl = document.createElement("meta");
      ogUrl.setAttribute("property", "og:url");
      ogUrl.content = "http://bits.blogs.nytimes.com/2011/12/08/a-twitter-for-my-sister/";
      document.head.insertBefore(ogUrl, linkTag);

      var twttrTitle = "";
      twttrTitle = document.createElement("meta");
      twttrTitle.setAttribute("property", "og:title");
      twttrTitle.content = this.content.title;
      document.head.insertBefore(twttrTitle, linkTag);

      var twttrImg = "";
      twttrImg = document.createElement("meta");
      twttrImg.setAttribute("property", "og:image");
      twttrImg.content = image;
      document.head.insertBefore(twttrImg, linkTag);
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Content__["a" /* default */]]
});

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(466);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("f9cd1882", content, true, {});

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".btn-fb.lg[data-v-28bf1643]:focus,.btn-gg.lg[data-v-28bf1643]:focus,.btn-hamb[data-v-28bf1643]:focus,.btn-ico[data-v-28bf1643]:focus,.btn-lg-hollow[data-v-28bf1643]:focus,.btn-lg-primary[data-v-28bf1643]:focus,.btn-lg[data-v-28bf1643]:focus,.btn-md-hollow[data-v-28bf1643]:focus,.btn-md-primary[data-v-28bf1643]:focus,.btn-md[data-v-28bf1643]:focus,.btn-sm-hollow[data-v-28bf1643]:focus,.btn-sm-primary[data-v-28bf1643]:focus,.btn-sm[data-v-28bf1643]:focus,.btn-trans[data-v-28bf1643]:focus,.vlt-btn[data-v-28bf1643]:focus,.vlt-form-control[data-v-28bf1643]:focus,.vlt-form-outline[data-v-28bf1643],.vlt-input-control[data-v-28bf1643]:focus,.vlt-slct-input[data-v-28bf1643]:focus{outline:none}.vlt-form-control[data-v-28bf1643],.vlt-input-control[data-v-28bf1643],.vlt-slct-input[data-v-28bf1643]{background-color:transparent;border:0;padding:2px 0;font-size:14px;font-weight:300;border-radius:0;-webkit-appearance:none}.vlt-slct-grp[data-v-28bf1643]{position:relative}.vlt-slct-grp .ico-img[data-v-28bf1643]{position:absolute;right:4px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.vlt-slct-grp .ico-img img[data-v-28bf1643]{width:10px}.btn-fb.lg[data-v-28bf1643],.btn-gg.lg[data-v-28bf1643],.btn-hamb[data-v-28bf1643],.btn-ico[data-v-28bf1643],.btn-lg-hollow[data-v-28bf1643],.btn-lg-primary[data-v-28bf1643],.btn-lg[data-v-28bf1643],.btn-md-hollow[data-v-28bf1643],.btn-md-primary[data-v-28bf1643],.btn-md[data-v-28bf1643],.btn-sm-hollow[data-v-28bf1643],.btn-sm-primary[data-v-28bf1643],.btn-sm[data-v-28bf1643],.btn-trans[data-v-28bf1643],.vlt-btn[data-v-28bf1643]{border:0;text-transform:uppercase;width:100%;letter-spacing:1px}.btn-hamb[data-v-28bf1643],.btn-ico[data-v-28bf1643],.btn-trans[data-v-28bf1643]{background-color:transparent}.btn-ico img[data-v-28bf1643]{vertical-align:middle}.btn-fb.lg[data-v-28bf1643],.btn-gg.lg[data-v-28bf1643],.btn-lg-hollow[data-v-28bf1643],.btn-lg-primary[data-v-28bf1643],.btn-lg[data-v-28bf1643]{padding:12px;font-size:18px;font-weight:600;width:100%;border-radius:5px;color:#fff;background:#4558dd;cursor:pointer}.btn-lg.inverted[data-v-28bf1643],.inverted.btn-fb.lg[data-v-28bf1643],.inverted.btn-gg.lg[data-v-28bf1643],.inverted.btn-lg-hollow[data-v-28bf1643],.inverted.btn-lg-primary[data-v-28bf1643]{background:#fff;color:#4558dd}.btn-md-hollow[data-v-28bf1643],.btn-md-primary[data-v-28bf1643],.btn-md[data-v-28bf1643]{padding:7px;font-size:12px;font-weight:600;min-width:120px;border-radius:16px}.btn-sm-hollow[data-v-28bf1643],.btn-sm-primary[data-v-28bf1643],.btn-sm[data-v-28bf1643]{padding:5px;font-size:11px;font-weight:600;min-width:90px;border-radius:16px;letter-spacing:normal}.btn-hamb .vlt-light span[data-v-28bf1643],.vlt-light .bg-color[data-v-28bf1643],.vlt-light .btn-hamb span[data-v-28bf1643],.vlt-light .vlt-mtrl-group input:focus~.bar[data-v-28bf1643]:after,.vlt-light .vlt-mtrl-group input:focus~.bar[data-v-28bf1643]:before,.vlt-light .vlt-radio input:checked+label[data-v-28bf1643]:after,.vlt-mtrl-group .vlt-light input:focus~.bar[data-v-28bf1643]:after,.vlt-mtrl-group .vlt-light input:focus~.bar[data-v-28bf1643]:before,.vlt-radio .vlt-light input:checked+label[data-v-28bf1643]:after{background-color:#222}.vlt-light .text-color[data-v-28bf1643],.vlt-light .vlt-form-control[data-v-28bf1643]:-ms-input-placeholder,.vlt-light .vlt-form-control[data-v-28bf1643]::-ms-input-placeholder{color:#f5f5f5}.vlt-light .text-color[data-v-28bf1643],.vlt-light .vlt-form-control[data-v-28bf1643]:-ms-input-placeholder,.vlt-light .vlt-form-control[data-v-28bf1643]::-ms-input-placeholder,.vlt-light .vlt-form-control[data-v-28bf1643]::placeholder{color:#f5f5f5}.vlt-light .border-color[data-v-28bf1643],.vlt-light .vlt-mtrl-group input[data-v-28bf1643],.vlt-light .vlt-radio label[data-v-28bf1643]:before,.vlt-mtrl-group .vlt-light input[data-v-28bf1643],.vlt-radio .vlt-light label[data-v-28bf1643]:before{border-color:#222}.vlt-light .invert-bg-color[data-v-28bf1643]{background-color:#f5f5f5}.vlt-light .invert-text-color[data-v-28bf1643],.vlt-light .vlt-mtrl-group .bar[data-v-28bf1643]:after,.vlt-light .vlt-mtrl-group .bar[data-v-28bf1643]:before,.vlt-light .vlt-mtrl-group input:focus~label[data-v-28bf1643],.vlt-light .vlt-mtrl-group input:not(:placeholder-shown)~label[data-v-28bf1643],.vlt-light .vlt-mtrl-group input[data-v-28bf1643],.vlt-light .vlt-mtrl-group label[data-v-28bf1643],.vlt-light .vlt-slct-input[data-v-28bf1643],.vlt-mtrl-group .vlt-light .bar[data-v-28bf1643]:after,.vlt-mtrl-group .vlt-light .bar[data-v-28bf1643]:before,.vlt-mtrl-group .vlt-light input:focus~label[data-v-28bf1643],.vlt-mtrl-group .vlt-light input:not(:placeholder-shown)~label[data-v-28bf1643],.vlt-mtrl-group .vlt-light input[data-v-28bf1643],.vlt-mtrl-group .vlt-light label[data-v-28bf1643]{color:#222}.vlt-light .invert-border-color[data-v-28bf1643]{border-color:#f5f5f5}.vlt-light .btn-lg-primary[data-v-28bf1643],.vlt-light .btn-md-primary[data-v-28bf1643],.vlt-light .btn-sm-primary[data-v-28bf1643],.vlt-light .primary-bg[data-v-28bf1643]{color:#fff;background:#4558dd}.vlt-light .inverted.btn-lg-primary[data-v-28bf1643],.vlt-light .inverted.btn-md-primary[data-v-28bf1643],.vlt-light .inverted.btn-sm-primary[data-v-28bf1643],.vlt-light .primary-bg.inverted[data-v-28bf1643],.vlt-light .vlt-tags li[data-v-28bf1643],.vlt-tags .vlt-light li[data-v-28bf1643]{color:#4558dd;background:#fff}.vlt-light .btn-lg-hollow[data-v-28bf1643],.vlt-light .btn-md-hollow[data-v-28bf1643],.vlt-light .btn-sm-hollow[data-v-28bf1643],.vlt-light .hollow-bg[data-v-28bf1643]{color:#f5f5f5;background:transparent;border:2px solid #f5f5f5}.vlt-light .hollow-bg.inverted[data-v-28bf1643],.vlt-light .inverted.btn-lg-hollow[data-v-28bf1643],.vlt-light .inverted.btn-md-hollow[data-v-28bf1643],.vlt-light .inverted.btn-sm-hollow[data-v-28bf1643]{color:#5a5a5a;background:transparent;border:2px solid #5a5a5a}.vlt-light .hollow-bg.inverted.success[data-v-28bf1643],.vlt-light .inverted.success.btn-lg-hollow[data-v-28bf1643],.vlt-light .inverted.success.btn-md-hollow[data-v-28bf1643],.vlt-light .inverted.success.btn-sm-hollow[data-v-28bf1643]{background:#e5f6d2}.vlt-light .hollow-bg.inverted.error[data-v-28bf1643],.vlt-light .inverted.error.btn-lg-hollow[data-v-28bf1643],.vlt-light .inverted.error.btn-md-hollow[data-v-28bf1643],.vlt-light .inverted.error.btn-sm-hollow[data-v-28bf1643]{background:#f3a39a}.btn-hamb .vlt-dark span[data-v-28bf1643],.vlt-dark .bg-color[data-v-28bf1643],.vlt-dark .btn-hamb span[data-v-28bf1643],.vlt-dark .vlt-mtrl-group input:focus~.bar[data-v-28bf1643]:after,.vlt-dark .vlt-mtrl-group input:focus~.bar[data-v-28bf1643]:before,.vlt-dark .vlt-radio input:checked+label[data-v-28bf1643]:after,.vlt-mtrl-group .vlt-dark input:focus~.bar[data-v-28bf1643]:after,.vlt-mtrl-group .vlt-dark input:focus~.bar[data-v-28bf1643]:before,.vlt-radio .vlt-dark input:checked+label[data-v-28bf1643]:after{background-color:#f5f5f5}.vlt-dark .text-color[data-v-28bf1643],.vlt-dark .vlt-form-control[data-v-28bf1643]:-ms-input-placeholder,.vlt-dark .vlt-form-control[data-v-28bf1643]::-ms-input-placeholder{color:#222}.vlt-dark .text-color[data-v-28bf1643],.vlt-dark .vlt-form-control[data-v-28bf1643]:-ms-input-placeholder,.vlt-dark .vlt-form-control[data-v-28bf1643]::-ms-input-placeholder,.vlt-dark .vlt-form-control[data-v-28bf1643]::placeholder{color:#222}.vlt-dark .invert-bg-color[data-v-28bf1643]{background-color:#222}.vlt-dark .border-color[data-v-28bf1643],.vlt-dark .vlt-mtrl-group input[data-v-28bf1643],.vlt-dark .vlt-radio label[data-v-28bf1643]:before,.vlt-mtrl-group .vlt-dark input[data-v-28bf1643],.vlt-radio .vlt-dark label[data-v-28bf1643]:before{border-color:#f5f5f5}.vlt-dark .invert-text-color[data-v-28bf1643],.vlt-dark .vlt-mtrl-group .bar[data-v-28bf1643]:after,.vlt-dark .vlt-mtrl-group .bar[data-v-28bf1643]:before,.vlt-dark .vlt-mtrl-group input:focus~label[data-v-28bf1643],.vlt-dark .vlt-mtrl-group input:not(:placeholder-shown)~label[data-v-28bf1643],.vlt-dark .vlt-mtrl-group input[data-v-28bf1643],.vlt-dark .vlt-mtrl-group label[data-v-28bf1643],.vlt-dark .vlt-slct-input[data-v-28bf1643],.vlt-mtrl-group .vlt-dark .bar[data-v-28bf1643]:after,.vlt-mtrl-group .vlt-dark .bar[data-v-28bf1643]:before,.vlt-mtrl-group .vlt-dark input:focus~label[data-v-28bf1643],.vlt-mtrl-group .vlt-dark input:not(:placeholder-shown)~label[data-v-28bf1643],.vlt-mtrl-group .vlt-dark input[data-v-28bf1643],.vlt-mtrl-group .vlt-dark label[data-v-28bf1643]{color:#f5f5f5}.vlt-dark .invert-border-color[data-v-28bf1643]{border-color:#222}.vlt-dark .btn-lg-primary[data-v-28bf1643],.vlt-dark .btn-md-primary[data-v-28bf1643],.vlt-dark .btn-sm-primary[data-v-28bf1643],.vlt-dark .primary-bg[data-v-28bf1643]{color:#222;background:#f5f5f5;background:-webkit-gradient(linear,left top,right top,from(#f5f5f5),to(#c3c3c3));background:linear-gradient(90deg,#f5f5f5,#c3c3c3)}.vlt-dark .btn-lg-hollow[data-v-28bf1643],.vlt-dark .btn-md-hollow[data-v-28bf1643],.vlt-dark .btn-sm-hollow[data-v-28bf1643],.vlt-dark .hollow-bg[data-v-28bf1643]{color:#f5f5f5;background:transparent;border:2px solid #f5f5f5}.vlt-link[data-v-28bf1643]{cursor:pointer;text-decoration:none;-webkit-transition:all .3s ease;transition:all .3s ease}.vlt-link[data-v-28bf1643]:hover{text-decoration:none}.form-message[data-v-28bf1643]{text-align:center;color:#df4d3d;-webkit-transition:all .3s ease;transition:all .3s ease}.btn-hamb span[data-v-28bf1643]{width:22px;height:2px;display:block;margin-bottom:5px}.btn-lg-primary[data-v-28bf1643]{font-family:ProximanovaBold}.btn-lg-primary[data-v-28bf1643]:hover{background:#5668e6}.btn-lg-hollow[data-v-28bf1643]{padding:10px}.btn-md-hollow[data-v-28bf1643]{padding:6px}.btn-sm-hollow[data-v-28bf1643]{padding:4px}.btn-fb[data-v-28bf1643]{background-color:#4267b2;color:#f5f5f5}.btn-gg[data-v-28bf1643]{background-color:#df4d3d;color:#f5f5f5}.vlt-btn-ico[data-v-28bf1643]{background:transparent;border:0}.vlt-btn-ico img[data-v-28bf1643]{width:24px}.vlt-btn-ico.lite[data-v-28bf1643]{color:#f5f5f5}.vlt-btn-ico.dark[data-v-28bf1643]{color:#222}.vlt-btn-ico .fa[data-v-28bf1643]{font-size:18px}.vlt-input-group label[data-v-28bf1643]{display:block;font-size:16px;color:#212121}.vlt-input-group label.error[data-v-28bf1643]{color:#f88}.vlt-input-group input[type=date][data-v-28bf1643],.vlt-input-group input[type=email][data-v-28bf1643],.vlt-input-group input[type=password][data-v-28bf1643],.vlt-input-group input[type=search][data-v-28bf1643],.vlt-input-group input[type=text][data-v-28bf1643],.vlt-input-group textarea[data-v-28bf1643]{border:0;border-bottom:1px solid rgba(0,0,0,.3);font-size:14px;height:40px;width:100%;background-color:transparent}.vlt-input-group input[type=date][data-v-28bf1643]::-webkit-input-placeholder,.vlt-input-group input[type=email][data-v-28bf1643]::-webkit-input-placeholder,.vlt-input-group input[type=password][data-v-28bf1643]::-webkit-input-placeholder,.vlt-input-group input[type=search][data-v-28bf1643]::-webkit-input-placeholder,.vlt-input-group input[type=text][data-v-28bf1643]::-webkit-input-placeholder,.vlt-input-group textarea[data-v-28bf1643]::-webkit-input-placeholder{color:#b7b7b7}.vlt-input-group input[type=date][data-v-28bf1643]::-moz-placeholder,.vlt-input-group input[type=email][data-v-28bf1643]::-moz-placeholder,.vlt-input-group input[type=password][data-v-28bf1643]::-moz-placeholder,.vlt-input-group input[type=search][data-v-28bf1643]::-moz-placeholder,.vlt-input-group input[type=text][data-v-28bf1643]::-moz-placeholder,.vlt-input-group textarea[data-v-28bf1643]::-moz-placeholder{color:#b7b7b7}.vlt-input-group input[type=date][data-v-28bf1643]:-ms-input-placeholder,.vlt-input-group input[type=email][data-v-28bf1643]:-ms-input-placeholder,.vlt-input-group input[type=password][data-v-28bf1643]:-ms-input-placeholder,.vlt-input-group input[type=search][data-v-28bf1643]:-ms-input-placeholder,.vlt-input-group input[type=text][data-v-28bf1643]:-ms-input-placeholder,.vlt-input-group textarea[data-v-28bf1643]:-ms-input-placeholder{color:#b7b7b7}.vlt-input-group input[type=date][data-v-28bf1643]:-moz-placeholder,.vlt-input-group input[type=email][data-v-28bf1643]:-moz-placeholder,.vlt-input-group input[type=password][data-v-28bf1643]:-moz-placeholder,.vlt-input-group input[type=search][data-v-28bf1643]:-moz-placeholder,.vlt-input-group input[type=text][data-v-28bf1643]:-moz-placeholder,.vlt-input-group textarea[data-v-28bf1643]:-moz-placeholder{color:#b7b7b7}.vlt-input-group textarea[data-v-28bf1643]{resize:vertical}.vlt-input-group.input-ico[data-v-28bf1643]{background-repeat:no-repeat;background-size:18px;background-position:95% 34px}.vlt-input-group.input-ico input[type=password][data-v-28bf1643],.vlt-input-group.input-ico input[type=text][data-v-28bf1643]{padding-right:38px}.vlt-input[data-v-28bf1643]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none}.vlt-mtrl-group[data-v-28bf1643]{position:relative}.vlt-mtrl-group label[data-v-28bf1643]{font-size:15px;font-weight:400;position:absolute;pointer-events:none;left:5px;top:10px;transition:all .2s ease;-moz-transition:.2s ease all;-webkit-transition:all .2s ease}.vlt-mtrl-group label.error[data-v-28bf1643]{color:#ef5350}.vlt-mtrl-group .bar[data-v-28bf1643]{position:relative;display:block}.vlt-mtrl-group .bar[data-v-28bf1643]:after,.vlt-mtrl-group .bar[data-v-28bf1643]:before{content:\"\";height:1px;width:0;bottom:1px;position:absolute;transition:all .2s ease;-moz-transition:.2s ease all;-webkit-transition:all .2s ease}.vlt-mtrl-group .bar[data-v-28bf1643]:before{left:50%}.vlt-mtrl-group .bar[data-v-28bf1643]:after{right:50%}.vlt-mtrl-group .highlight[data-v-28bf1643]{position:absolute;height:60%;width:auto;top:25%;left:0;pointer-events:none;opacity:.5}.vlt-mtrl-group input[data-v-28bf1643]{font-size:15px;padding:8px 8px 8px 5px;display:block;width:100%;border:none;border-bottom:1px solid transparent;background-color:transparent}.vlt-mtrl-group input:focus~label[data-v-28bf1643],.vlt-mtrl-group input:not(:placeholder-shown)~label[data-v-28bf1643]{top:-14px;font-size:12px}.vlt-mtrl-group input:focus~label.error[data-v-28bf1643],.vlt-mtrl-group input:not(:placeholder-shown)~label.error[data-v-28bf1643]{color:#ef5350}.vlt-mtrl-group input:focus~.bar[data-v-28bf1643]:after,.vlt-mtrl-group input:focus~.bar[data-v-28bf1643]:before{width:50%}.vlt-mtrl-group input:focus~.highlight[data-v-28bf1643]{-webkit-animation:inputHighlighter-data-v-28bf1643 .3s ease;animation:inputHighlighter-data-v-28bf1643 .3s ease}@-webkit-keyframes inputHighlighter-data-v-28bf1643{to{width:0;background:transparent}}@keyframes inputHighlighter-data-v-28bf1643{to{width:0;background:transparent}}.vlt-form-control[data-v-28bf1643]{min-width:200px}.vlt-form-control[data-v-28bf1643]::-webkit-input-placeholder{opacity:1}.vlt-form-control[data-v-28bf1643]:-ms-input-placeholder,.vlt-form-control[data-v-28bf1643]::-ms-input-placeholder{opacity:1}.vlt-form-control[data-v-28bf1643]::placeholder{opacity:1}.vlt-input[data-v-28bf1643]{position:relative}.vlt-input .ico-img[data-v-28bf1643]{position:absolute;top:10px;right:10px}.vlt-input .ico-img img[data-v-28bf1643]{width:18px}.grid-title[data-v-28bf1643]{margin-bottom:15px}.vlt-slct-input[data-v-28bf1643]{border:2px solid #e2e2e2;border-radius:3px;font-size:14px;height:40px;width:100%;background-color:transparent;padding:0 20px}.vlt-radio[data-v-28bf1643]{position:relative}.vlt-radio.inline[data-v-28bf1643]{display:inline-block;margin-right:10px}.vlt-radio input[data-v-28bf1643]{opacity:0;position:absolute}.vlt-radio input:checked+label[data-v-28bf1643]:after{width:7px;height:7px;left:4px;top:6px;border-radius:50%}.vlt-radio label[data-v-28bf1643]{position:relative;padding-left:20px;font-weight:300}.vlt-radio label[data-v-28bf1643]:after,.vlt-radio label[data-v-28bf1643]:before{position:absolute;content:\"\"}.vlt-radio label[data-v-28bf1643]:before{width:15px;height:15px;border-radius:50%;left:0;top:2px;border:2px solid #f5f5f5}.mx-input[data-v-28bf1643]{border-radius:0!important;-webkit-box-shadow:none!important;box-shadow:none!important}.mx-input-icon[data-v-28bf1643]{display:none!important}.vlt-tags li[data-v-28bf1643]{display:inline-block;border-radius:20px;margin-right:10px;text-align:center}.vlt-tags li .tag-link[data-v-28bf1643],.vlt-tags li a[data-v-28bf1643]{display:block;font-size:13px;text-transform:uppercase;padding:2px 10px;min-width:90px}.vlt-tags li[data-v-28bf1643]:last-child{margin-right:0}.vlt-light .vlt-tags li .tag-link[data-v-28bf1643],.vlt-light .vlt-tags li a[data-v-28bf1643]{color:#f5f5f5}.vlt-dark .vlt-tags li .tag-link[data-v-28bf1643],.vlt-dark .vlt-tags li a[data-v-28bf1643]{color:#222}.popup-animate-enter-active[data-v-28bf1643],.popup-animate-leave-active[data-v-28bf1643]{-webkit-transition:opacity .5s;transition:opacity .5s}.popup-animate-enter[data-v-28bf1643],.popup-animate-leave-to[data-v-28bf1643]{opacity:0}.mx-input-append[data-v-28bf1643]{display:none!important}input[type=text][data-v-28bf1643]::-ms-clear,input[type=text][data-v-28bf1643]::-ms-reveal{display:none;width:0;height:0}input[type=search][data-v-28bf1643]::-webkit-search-cancel-button,input[type=search][data-v-28bf1643]::-webkit-search-decoration,input[type=search][data-v-28bf1643]::-webkit-search-results-button,input[type=search][data-v-28bf1643]::-webkit-search-results-decoration{display:none}button[data-v-28bf1643]:disabled:hover{cursor:not-allowed}.button-hover[data-v-28bf1643]{-webkit-transition:all .4s cubic-bezier(.47,0,.75,.72);transition:all .4s cubic-bezier(.47,0,.75,.72);cursor:pointer}.button-hover[data-v-28bf1643]:hover{color:#fff!important;background-color:#5a5a5a!important}.button-click-hover[data-v-28bf1643]{-webkit-transition-duration:.4s;transition-duration:.4s}.button-click-hover[data-v-28bf1643]:hover{background:-webkit-gradient(linear,left top,right top,from(#5a5a5a),to(#222))!important;background:linear-gradient(90deg,#5a5a5a,#222)!important;-webkit-transform:translateY(1px);transform:translateY(1px)}.player-container[data-v-28bf1643]{margin:0 auto;width:950px}.mx-calendar-content .cell.actived[data-v-28bf1643]{background-color:#222}.error-message[data-v-28bf1643]{color:red}.formError[data-v-28bf1643]{border-bottom:1px solid red!important}.vlt-share-contain[data-v-28bf1643]{position:relative;z-index:89}.vlt-share-contain .share-popup[data-v-28bf1643]{position:absolute;background-color:#e6e6e6;padding:2px 8px;width:210px;border-radius:40px;top:0;left:100%;-webkit-transition:.5s;transition:.5s}.vlt-share-contain .share-popup ul[data-v-28bf1643]{text-align:center}.vlt-share-contain .share-popup ul li[data-v-28bf1643]{display:inline-block;margin-right:15px;cursor:pointer}.vlt-share-contain .share-popup ul li img[data-v-28bf1643]{width:40px;padding:8px;vertical-align:middle}.vlt-share-contain .share-popup ul li[data-v-28bf1643]:last-child{margin-right:0}.vlt-share-contain .vlt-btn-ico[data-v-28bf1643]{cursor:pointer}.share-overlay[data-v-28bf1643]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:88}.share-icon[data-v-28bf1643]{padding-top:0}.share-icon img[data-v-28bf1643]{width:30px;margin-bottom:0}@media only screen and (max-width:576px){.share-icon[data-v-28bf1643]{padding-top:0}.vlt-share-contain .share-popup[data-v-28bf1643]{width:35px;margin-left:10px;border-radius:20px;position:absolute;background-color:#e6e6e6;padding:5px;top:0;left:100%;-webkit-transition:.5s;transition:.5s;text-align:center}.vlt-share-contain .share-popup ul li[data-v-28bf1643]{margin-right:7px;display:block}.vlt-share-contain .share-popup ul li img[data-v-28bf1643]{width:25px;padding:5px}.vlt-share-contain .share-popup ul li[data-v-28bf1643]:last-child{margin-right:0}}@media only screen and (min-width:576px) and (max-width:768px){.share-icon[data-v-28bf1643]{padding-top:0}.vlt-share-contain .share-popup[data-v-28bf1643]{width:35px;margin-left:10px;border-radius:20px;position:absolute;background-color:#e6e6e6;padding:5px;top:0;left:50%;-webkit-transition:.5s;transition:.5s;text-align:center}.vlt-share-contain .share-popup ul li[data-v-28bf1643]{margin-right:7px;display:block}.vlt-share-contain .share-popup ul li img[data-v-28bf1643]{width:25px;padding:5px}.vlt-share-contain .share-popup ul li[data-v-28bf1643]:last-child{margin-right:0}}.share-tag[data-v-28bf1643]{color:#fff;font-family:ProximanovaRegular;font-size:18px;font-weight:700;line-height:24px;text-align:center}@media screen and (min-width:1900px){.share-icon[data-v-28bf1643]{padding-top:0}.share-icon img[data-v-28bf1643]{width:35px}}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Slots/share.vue"],"names":[],"mappings":"AACA,wqBAAwqB,YAAY,CACnrB,AACD,wGAAwG,6BAA6B,SAAS,cAAc,eAAe,gBAAgB,gBAAgB,uBAAuB,CACjO,AACD,+BAA+B,iBAAiB,CAC/C,AACD,wCAAwC,kBAAkB,UAAU,QAAQ,mCAAmC,0BAA0B,CACxI,AACD,4CAA4C,UAAU,CACrD,AACD,ibAAib,SAAS,yBAAyB,WAAW,kBAAkB,CAC/e,AACD,iFAAiF,4BAA4B,CAC5G,AACD,8BAA8B,qBAAqB,CAClD,AACD,kJAAkJ,aAAa,eAAe,gBAAgB,WAAW,kBAAkB,WAAW,mBAAmB,cAAc,CACtQ,AACD,+LAA+L,gBAAgB,aAAa,CAC3N,AACD,0FAA0F,YAAY,eAAe,gBAAgB,gBAAgB,kBAAkB,CACtK,AACD,0FAA0F,YAAY,eAAe,gBAAgB,eAAe,mBAAmB,qBAAqB,CAC3L,AACD,4gBAAshB,qBAAqB,CAC1iB,AAGD,iLAAsP,aAAa,CAClQ,AACD,4OAA4O,aAAa,CACxP,AACD,sPAAwP,iBAAiB,CACxQ,AACD,6CAA6C,wBAAwB,CACpE,AACD,6xBAAqyB,UAAU,CAC9yB,AACD,iDAAiD,oBAAoB,CACpE,AACD,4KAA4K,WAAW,kBAAkB,CACxM,AACD,kSAAkS,cAAc,eAAe,CAC9T,AACD,wKAAwK,cAAc,uBAAuB,wBAAwB,CACpO,AACD,4MAA4M,cAAc,uBAAuB,wBAAwB,CACxQ,AACD,4OAA4O,kBAAkB,CAC7P,AACD,oOAAoO,kBAAkB,CACrP,AACD,mgBAA6gB,wBAAwB,CACpiB,AAGD,8KAAkP,UAAU,CAC3P,AACD,wOAAwO,UAAU,CACjP,AACD,4CAA4C,qBAAqB,CAChE,AACD,iPAAmP,oBAAoB,CACtQ,AACD,+wBAAuxB,aAAa,CACnyB,AACD,gDAAgD,iBAAiB,CAChE,AACD,wKAAwK,WAAW,mBAAmB,iFAAqF,iDAAsD,CAChV,AACD,oKAAoK,cAAc,uBAAuB,wBAAwB,CAChO,AACD,2BAA2B,eAAe,qBAAqB,gCAAiC,uBAAwB,CACvH,AACD,iCAAiC,oBAAoB,CACpD,AACD,+BAA+B,kBAAkB,cAAc,gCAAiC,uBAAwB,CACvH,AACD,gCAAgC,WAAW,WAAW,cAAc,iBAAiB,CACpF,AACD,iCAAiC,2BAA6B,CAC7D,AACD,uCAAuC,kBAAkB,CACxD,AACD,gCAAgC,YAAY,CAC3C,AACD,gCAAgC,WAAW,CAC1C,AACD,gCAAgC,WAAW,CAC1C,AACD,yBAAyB,yBAAyB,aAAa,CAC9D,AACD,yBAAyB,yBAAyB,aAAa,CAC9D,AACD,8BAA8B,uBAAuB,QAAQ,CAC5D,AACD,kCAAkC,UAAU,CAC3C,AACD,mCAAmC,aAAa,CAC/C,AACD,mCAAmC,UAAU,CAC5C,AACD,kCAAkC,cAAc,CAC/C,AACD,wCAAwC,cAAc,eAAe,aAAa,CACjF,AACD,8CAA8C,UAAa,CAC1D,AACD,iTAA2T,SAAS,uCAAwC,eAAe,YAAY,WAAW,4BAA4B,CAC7a,AACD,mdAA6d,aAAa,CACze,AACD,6ZAAua,aAAa,CACnb,AACD,qbAA+b,aAAa,CAC3c,AACD,uZAAia,aAAa,CAC7a,AACD,2CAA2C,eAAe,CACzD,AACD,4CAA4C,4BAA4B,qBAAqB,4BAA4B,CACxH,AACD,8HAAkI,kBAAkB,CACnJ,AACD,4BAA8C,yBAAyB,sBAAsB,qBAAqB,iBAAiB,sBAAsB,CACxJ,AAKD,iCAAiC,iBAAiB,CACjD,AACD,uCAAuC,eAAe,gBAAmB,kBAAkB,oBAAoB,SAAS,SAAS,wBAAyB,6BAA8B,+BAAgC,CACvN,AACD,6CAA6C,aAAa,CACzD,AACD,sCAAsC,kBAAkB,aAAa,CACpE,AACD,yFAAyF,WAAW,WAAW,QAAQ,WAAW,kBAAkB,wBAAyB,6BAA8B,+BAAgC,CAC1O,AACD,6CAA6C,QAAQ,CACpD,AACD,4CAA4C,SAAS,CACpD,AACD,4CAA4C,kBAAkB,WAAW,WAAW,QAAQ,OAAO,oBAAoB,UAAW,CACjI,AACD,uCAAuC,eAAe,wBAAwB,cAAc,WAAW,YAAY,oCAAoC,4BAA4B,CAClL,AACD,wHAA4H,UAAU,cAAc,CACnJ,AACD,oIAAwI,aAAa,CACpJ,AACD,iHAAqH,SAAS,CAC7H,AACD,wDAA0D,4DAA6D,mDAAoD,CAC1K,AACD,oDAGA,GAAG,QAAQ,sBAAsB,CAChC,CACA,AACD,4CAGA,GAAG,QAAQ,sBAAsB,CAChC,CACA,AACD,mCAAmC,eAAe,CACjD,AACD,8DAA8D,SAAS,CACtE,AAGD,mHAA0D,SAAS,CAClE,AACD,gDAAgD,SAAS,CACxD,AACD,4BAA4B,iBAAiB,CAC5C,AACD,qCAAqC,kBAAkB,SAAS,UAAU,CACzE,AACD,yCAAyC,UAAU,CAClD,AACD,6BAA6B,kBAAkB,CAC9C,AACD,iCAAiC,yBAAyB,kBAAkB,eAAe,YAAY,WAAW,6BAA6B,cAAgB,CAC9J,AACD,4BAA4B,iBAAiB,CAC5C,AACD,mCAAmC,qBAAqB,iBAAiB,CACxE,AACD,kCAAkC,UAAU,iBAAiB,CAC5D,AACD,sDAAuD,UAAU,WAAW,SAAS,QAAQ,iBAAiB,CAC7G,AACD,kCAAkC,kBAAkB,kBAAkB,eAAe,CACpF,AACD,iFAAmF,kBAAkB,UAAU,CAC9G,AACD,yCAA0C,WAAW,YAAY,kBAAkB,OAAO,QAAQ,wBAAwB,CACzH,AACD,2BAA2B,0BAA2B,kCAAmC,yBAA0B,CAClH,AACD,gCAAgC,sBAAuB,CACtD,AACD,8BAA8B,qBAAqB,mBAAmB,kBAAkB,iBAAiB,CACxG,AACD,wEAAwE,cAAc,eAAe,yBAAyB,iBAAiB,cAAc,CAC5J,AACD,yCAAyC,cAAc,CACtD,AACD,8FAA8F,aAAa,CAC1G,AACD,4FAA4F,UAAU,CACrG,AACD,0FAA0F,+BAA+B,sBAAsB,CAC9I,AACD,+EAA+E,SAAS,CACvF,AACD,kCAAkC,sBAAuB,CACxD,AASD,2FAA8C,aAAa,QAAQ,QAAQ,CAC1E,AACD,2QAAmR,YAAY,CAC9R,AACD,uCAAuC,kBAAkB,CACxD,AACD,+BAA+B,uDAA8D,+CAAsD,cAAc,CAChK,AACD,qCAAqC,qBAAuB,kCAAmC,CAC9F,AACD,qCAAqC,gCAAiC,uBAAwB,CAC7F,AACD,2CAA2C,wFAA6F,yDAA+D,kCAAkC,yBAAyB,CACjQ,AACD,mCAAmC,cAAc,WAAW,CAC3D,AACD,oDAAoD,qBAAqB,CACxE,AACD,gCAAgC,SAAS,CACxC,AACD,4BAA4B,qCAAsC,CACjE,AACD,oCAAoC,kBAAkB,UAAU,CAC/D,AACD,iDAAiD,kBAAkB,yBAAyB,gBAAgB,YAAY,mBAAmB,MAAQ,UAAU,uBAAwB,cAAe,CACnM,AACD,oDAAoD,iBAAiB,CACpE,AACD,uDAAuD,qBAAqB,kBAAkB,cAAc,CAC3G,AACD,2DAA2D,WAAW,YAAY,qBAAqB,CACtG,AACD,kEAAkE,cAAc,CAC/E,AACD,iDAAiD,cAAc,CAC9D,AACD,gCAAgC,eAAe,MAAM,OAAO,WAAW,YAAY,UAAU,CAC5F,AACD,6BAA6B,aAAa,CACzC,AACD,iCAAiC,WAAW,eAAe,CAC1D,AACD,yCACA,6BAA6B,aAAa,CACzC,AACD,iDAAiD,WAAW,iBAAiB,mBAAmB,kBAAkB,yBAAyB,YAAY,MAAQ,UAAU,uBAAwB,eAAgB,iBAAiB,CACjO,AACD,uDAAuD,iBAAiB,aAAa,CACpF,AACD,2DAA2D,WAAW,WAAW,CAChF,AACD,kEAAkE,cAAc,CAC/E,CACA,AACD,+DACA,6BAA6B,aAAa,CACzC,AACD,iDAAiD,WAAW,iBAAiB,mBAAmB,kBAAkB,yBAAyB,YAAY,MAAQ,SAAS,uBAAwB,eAAgB,iBAAiB,CAChO,AACD,uDAAuD,iBAAiB,aAAa,CACpF,AACD,2DAA2D,WAAW,WAAW,CAChF,AACD,kEAAkE,cAAc,CAC/E,CACA,AACD,4BAA4B,WAAc,+BAAiC,eAAe,gBAAiB,iBAAiB,iBAAiB,CAC5I,AACD,qCACA,6BAA6B,aAAa,CACzC,AACD,iCAAiC,UAAU,CAC1C,CACA","file":"share.vue","sourcesContent":["\n.vlt-form-outline[data-v-28bf1643],.vlt-input-control[data-v-28bf1643]:focus,.vlt-form-control[data-v-28bf1643]:focus,.vlt-slct-input[data-v-28bf1643]:focus,.vlt-btn[data-v-28bf1643]:focus,.btn-trans[data-v-28bf1643]:focus,.btn-hamb[data-v-28bf1643]:focus,.btn-ico[data-v-28bf1643]:focus,.btn-lg[data-v-28bf1643]:focus,.btn-lg-primary[data-v-28bf1643]:focus,.btn-lg-hollow[data-v-28bf1643]:focus,.btn-fb.lg[data-v-28bf1643]:focus,.btn-gg.lg[data-v-28bf1643]:focus,.btn-md[data-v-28bf1643]:focus,.btn-md-primary[data-v-28bf1643]:focus,.btn-md-hollow[data-v-28bf1643]:focus,.btn-sm[data-v-28bf1643]:focus,.btn-sm-primary[data-v-28bf1643]:focus,.btn-sm-hollow[data-v-28bf1643]:focus{outline:none\n}\n.vlt-input-control[data-v-28bf1643],.vlt-form-control[data-v-28bf1643],.vlt-slct-input[data-v-28bf1643]{background-color:transparent;border:0;padding:2px 0;font-size:14px;font-weight:300;border-radius:0;-webkit-appearance:none\n}\n.vlt-slct-grp[data-v-28bf1643]{position:relative\n}\n.vlt-slct-grp .ico-img[data-v-28bf1643]{position:absolute;right:4px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)\n}\n.vlt-slct-grp .ico-img img[data-v-28bf1643]{width:10px\n}\n.vlt-btn[data-v-28bf1643],.btn-trans[data-v-28bf1643],.btn-hamb[data-v-28bf1643],.btn-ico[data-v-28bf1643],.btn-lg[data-v-28bf1643],.btn-lg-primary[data-v-28bf1643],.btn-lg-hollow[data-v-28bf1643],.btn-fb.lg[data-v-28bf1643],.btn-gg.lg[data-v-28bf1643],.btn-md[data-v-28bf1643],.btn-md-primary[data-v-28bf1643],.btn-md-hollow[data-v-28bf1643],.btn-sm[data-v-28bf1643],.btn-sm-primary[data-v-28bf1643],.btn-sm-hollow[data-v-28bf1643]{border:0;text-transform:uppercase;width:100%;letter-spacing:1px\n}\n.btn-trans[data-v-28bf1643],.btn-hamb[data-v-28bf1643],.btn-ico[data-v-28bf1643]{background-color:transparent\n}\n.btn-ico img[data-v-28bf1643]{vertical-align:middle\n}\n.btn-lg[data-v-28bf1643],.btn-lg-primary[data-v-28bf1643],.btn-lg-hollow[data-v-28bf1643],.btn-fb.lg[data-v-28bf1643],.btn-gg.lg[data-v-28bf1643]{padding:12px;font-size:18px;font-weight:600;width:100%;border-radius:5px;color:#fff;background:#4558DD;cursor:pointer\n}\n.btn-lg.inverted[data-v-28bf1643],.inverted.btn-lg-primary[data-v-28bf1643],.inverted.btn-lg-hollow[data-v-28bf1643],.inverted.btn-fb.lg[data-v-28bf1643],.inverted.btn-gg.lg[data-v-28bf1643]{background:#fff;color:#4558DD\n}\n.btn-md[data-v-28bf1643],.btn-md-primary[data-v-28bf1643],.btn-md-hollow[data-v-28bf1643]{padding:7px;font-size:12px;font-weight:600;min-width:120px;border-radius:16px\n}\n.btn-sm[data-v-28bf1643],.btn-sm-primary[data-v-28bf1643],.btn-sm-hollow[data-v-28bf1643]{padding:5px;font-size:11px;font-weight:600;min-width:90px;border-radius:16px;letter-spacing:normal\n}\n.vlt-light .bg-color[data-v-28bf1643],.vlt-light .btn-hamb span[data-v-28bf1643],.btn-hamb .vlt-light span[data-v-28bf1643],.vlt-light .vlt-mtrl-group input:focus ~ .bar[data-v-28bf1643]:before,.vlt-mtrl-group .vlt-light input:focus ~ .bar[data-v-28bf1643]:before,.vlt-light .vlt-mtrl-group input:focus ~ .bar[data-v-28bf1643]:after,.vlt-mtrl-group .vlt-light input:focus ~ .bar[data-v-28bf1643]:after,.vlt-light .vlt-radio input:checked+label[data-v-28bf1643]::after,.vlt-radio .vlt-light input:checked+label[data-v-28bf1643]::after{background-color:#222\n}\n.vlt-light .text-color[data-v-28bf1643],.vlt-light .vlt-form-control[data-v-28bf1643]:-ms-input-placeholder,.vlt-light .vlt-form-control[data-v-28bf1643]:-ms-input-placeholder,.vlt-light .vlt-form-control[data-v-28bf1643]::-ms-input-placeholder{color:#f5f5f5\n}\n.vlt-light .text-color[data-v-28bf1643],.vlt-light .vlt-form-control[data-v-28bf1643]::-ms-input-placeholder,.vlt-light .vlt-form-control[data-v-28bf1643]:-ms-input-placeholder,.vlt-light .vlt-form-control[data-v-28bf1643]::-ms-input-placeholder{color:#f5f5f5\n}\n.vlt-light .text-color[data-v-28bf1643],.vlt-light .vlt-form-control[data-v-28bf1643]::placeholder,.vlt-light .vlt-form-control[data-v-28bf1643]:-ms-input-placeholder,.vlt-light .vlt-form-control[data-v-28bf1643]::-ms-input-placeholder{color:#f5f5f5\n}\n.vlt-light .border-color[data-v-28bf1643],.vlt-light .vlt-mtrl-group input[data-v-28bf1643],.vlt-mtrl-group .vlt-light input[data-v-28bf1643],.vlt-light .vlt-radio label[data-v-28bf1643]::before,.vlt-radio .vlt-light label[data-v-28bf1643]::before{border-color:#222\n}\n.vlt-light .invert-bg-color[data-v-28bf1643]{background-color:#f5f5f5\n}\n.vlt-light .invert-text-color[data-v-28bf1643],.vlt-light .vlt-mtrl-group label[data-v-28bf1643],.vlt-mtrl-group .vlt-light label[data-v-28bf1643],.vlt-light .vlt-mtrl-group .bar[data-v-28bf1643]:before,.vlt-mtrl-group .vlt-light .bar[data-v-28bf1643]:before,.vlt-light .vlt-mtrl-group .bar[data-v-28bf1643]:after,.vlt-mtrl-group .vlt-light .bar[data-v-28bf1643]:after,.vlt-light .vlt-mtrl-group input[data-v-28bf1643],.vlt-mtrl-group .vlt-light input[data-v-28bf1643],.vlt-light .vlt-mtrl-group input:focus ~ label[data-v-28bf1643],.vlt-mtrl-group .vlt-light input:focus ~ label[data-v-28bf1643],.vlt-light .vlt-mtrl-group input:not(:placeholder-shown) ~ label[data-v-28bf1643],.vlt-mtrl-group .vlt-light input:not(:placeholder-shown) ~ label[data-v-28bf1643],.vlt-light .vlt-slct-input[data-v-28bf1643]{color:#222\n}\n.vlt-light .invert-border-color[data-v-28bf1643]{border-color:#f5f5f5\n}\n.vlt-light .primary-bg[data-v-28bf1643],.vlt-light .btn-lg-primary[data-v-28bf1643],.vlt-light .btn-md-primary[data-v-28bf1643],.vlt-light .btn-sm-primary[data-v-28bf1643]{color:#fff;background:#4558DD\n}\n.vlt-light .primary-bg.inverted[data-v-28bf1643],.vlt-light .inverted.btn-lg-primary[data-v-28bf1643],.vlt-light .inverted.btn-md-primary[data-v-28bf1643],.vlt-light .inverted.btn-sm-primary[data-v-28bf1643],.vlt-light .vlt-tags li[data-v-28bf1643],.vlt-tags .vlt-light li[data-v-28bf1643]{color:#4558DD;background:#fff\n}\n.vlt-light .hollow-bg[data-v-28bf1643],.vlt-light .btn-lg-hollow[data-v-28bf1643],.vlt-light .btn-md-hollow[data-v-28bf1643],.vlt-light .btn-sm-hollow[data-v-28bf1643]{color:#f5f5f5;background:transparent;border:2px solid #f5f5f5\n}\n.vlt-light .hollow-bg.inverted[data-v-28bf1643],.vlt-light .inverted.btn-lg-hollow[data-v-28bf1643],.vlt-light .inverted.btn-md-hollow[data-v-28bf1643],.vlt-light .inverted.btn-sm-hollow[data-v-28bf1643]{color:#5a5a5a;background:transparent;border:2px solid #5a5a5a\n}\n.vlt-light .hollow-bg.inverted.success[data-v-28bf1643],.vlt-light .inverted.success.btn-lg-hollow[data-v-28bf1643],.vlt-light .inverted.success.btn-md-hollow[data-v-28bf1643],.vlt-light .inverted.success.btn-sm-hollow[data-v-28bf1643]{background:#e5f6d2\n}\n.vlt-light .hollow-bg.inverted.error[data-v-28bf1643],.vlt-light .inverted.error.btn-lg-hollow[data-v-28bf1643],.vlt-light .inverted.error.btn-md-hollow[data-v-28bf1643],.vlt-light .inverted.error.btn-sm-hollow[data-v-28bf1643]{background:#f3a39a\n}\n.vlt-dark .bg-color[data-v-28bf1643],.vlt-dark .btn-hamb span[data-v-28bf1643],.btn-hamb .vlt-dark span[data-v-28bf1643],.vlt-dark .vlt-mtrl-group input:focus ~ .bar[data-v-28bf1643]:before,.vlt-mtrl-group .vlt-dark input:focus ~ .bar[data-v-28bf1643]:before,.vlt-dark .vlt-mtrl-group input:focus ~ .bar[data-v-28bf1643]:after,.vlt-mtrl-group .vlt-dark input:focus ~ .bar[data-v-28bf1643]:after,.vlt-dark .vlt-radio input:checked+label[data-v-28bf1643]::after,.vlt-radio .vlt-dark input:checked+label[data-v-28bf1643]::after{background-color:#f5f5f5\n}\n.vlt-dark .text-color[data-v-28bf1643],.vlt-dark .vlt-form-control[data-v-28bf1643]:-ms-input-placeholder,.vlt-dark .vlt-form-control[data-v-28bf1643]:-ms-input-placeholder,.vlt-dark .vlt-form-control[data-v-28bf1643]::-ms-input-placeholder{color:#222\n}\n.vlt-dark .text-color[data-v-28bf1643],.vlt-dark .vlt-form-control[data-v-28bf1643]::-ms-input-placeholder,.vlt-dark .vlt-form-control[data-v-28bf1643]:-ms-input-placeholder,.vlt-dark .vlt-form-control[data-v-28bf1643]::-ms-input-placeholder{color:#222\n}\n.vlt-dark .text-color[data-v-28bf1643],.vlt-dark .vlt-form-control[data-v-28bf1643]::placeholder,.vlt-dark .vlt-form-control[data-v-28bf1643]:-ms-input-placeholder,.vlt-dark .vlt-form-control[data-v-28bf1643]::-ms-input-placeholder{color:#222\n}\n.vlt-dark .invert-bg-color[data-v-28bf1643]{background-color:#222\n}\n.vlt-dark .border-color[data-v-28bf1643],.vlt-dark .vlt-mtrl-group input[data-v-28bf1643],.vlt-mtrl-group .vlt-dark input[data-v-28bf1643],.vlt-dark .vlt-radio label[data-v-28bf1643]::before,.vlt-radio .vlt-dark label[data-v-28bf1643]::before{border-color:#f5f5f5\n}\n.vlt-dark .invert-text-color[data-v-28bf1643],.vlt-dark .vlt-mtrl-group label[data-v-28bf1643],.vlt-mtrl-group .vlt-dark label[data-v-28bf1643],.vlt-dark .vlt-mtrl-group .bar[data-v-28bf1643]:before,.vlt-mtrl-group .vlt-dark .bar[data-v-28bf1643]:before,.vlt-dark .vlt-mtrl-group .bar[data-v-28bf1643]:after,.vlt-mtrl-group .vlt-dark .bar[data-v-28bf1643]:after,.vlt-dark .vlt-mtrl-group input[data-v-28bf1643],.vlt-mtrl-group .vlt-dark input[data-v-28bf1643],.vlt-dark .vlt-mtrl-group input:focus ~ label[data-v-28bf1643],.vlt-mtrl-group .vlt-dark input:focus ~ label[data-v-28bf1643],.vlt-dark .vlt-mtrl-group input:not(:placeholder-shown) ~ label[data-v-28bf1643],.vlt-mtrl-group .vlt-dark input:not(:placeholder-shown) ~ label[data-v-28bf1643],.vlt-dark .vlt-slct-input[data-v-28bf1643]{color:#f5f5f5\n}\n.vlt-dark .invert-border-color[data-v-28bf1643]{border-color:#222\n}\n.vlt-dark .primary-bg[data-v-28bf1643],.vlt-dark .btn-lg-primary[data-v-28bf1643],.vlt-dark .btn-md-primary[data-v-28bf1643],.vlt-dark .btn-sm-primary[data-v-28bf1643]{color:#222;background:#f5f5f5;background:-webkit-gradient(linear, left top, right top, from(#f5f5f5), to(#c3c3c3));background:linear-gradient(to right, #f5f5f5, #c3c3c3)\n}\n.vlt-dark .hollow-bg[data-v-28bf1643],.vlt-dark .btn-lg-hollow[data-v-28bf1643],.vlt-dark .btn-md-hollow[data-v-28bf1643],.vlt-dark .btn-sm-hollow[data-v-28bf1643]{color:#f5f5f5;background:transparent;border:2px solid #f5f5f5\n}\n.vlt-link[data-v-28bf1643]{cursor:pointer;text-decoration:none;-webkit-transition:all 0.3s ease;transition:all 0.3s ease\n}\n.vlt-link[data-v-28bf1643]:hover{text-decoration:none\n}\n.form-message[data-v-28bf1643]{text-align:center;color:#df4d3d;-webkit-transition:all 0.3s ease;transition:all 0.3s ease\n}\n.btn-hamb span[data-v-28bf1643]{width:22px;height:2px;display:block;margin-bottom:5px\n}\n.btn-lg-primary[data-v-28bf1643]{font-family:\"ProximanovaBold\"\n}\n.btn-lg-primary[data-v-28bf1643]:hover{background:#5668e6\n}\n.btn-lg-hollow[data-v-28bf1643]{padding:10px\n}\n.btn-md-hollow[data-v-28bf1643]{padding:6px\n}\n.btn-sm-hollow[data-v-28bf1643]{padding:4px\n}\n.btn-fb[data-v-28bf1643]{background-color:#4267b2;color:#f5f5f5\n}\n.btn-gg[data-v-28bf1643]{background-color:#df4d3d;color:#f5f5f5\n}\n.vlt-btn-ico[data-v-28bf1643]{background:transparent;border:0\n}\n.vlt-btn-ico img[data-v-28bf1643]{width:24px\n}\n.vlt-btn-ico.lite[data-v-28bf1643]{color:#f5f5f5\n}\n.vlt-btn-ico.dark[data-v-28bf1643]{color:#222\n}\n.vlt-btn-ico .fa[data-v-28bf1643]{font-size:18px\n}\n.vlt-input-group label[data-v-28bf1643]{display:block;font-size:16px;color:#212121\n}\n.vlt-input-group label.error[data-v-28bf1643]{color:#ff8888\n}\n.vlt-input-group input[type=\"text\"][data-v-28bf1643],.vlt-input-group input[type=\"search\"][data-v-28bf1643],.vlt-input-group input[type=\"date\"][data-v-28bf1643],.vlt-input-group input[type=\"password\"][data-v-28bf1643],.vlt-input-group input[type=\"email\"][data-v-28bf1643],.vlt-input-group textarea[data-v-28bf1643]{border:0;border-bottom:1px solid rgba(0,0,0,0.3);font-size:14px;height:40px;width:100%;background-color:transparent\n}\n.vlt-input-group input[type=\"text\"][data-v-28bf1643]::-webkit-input-placeholder,.vlt-input-group input[type=\"search\"][data-v-28bf1643]::-webkit-input-placeholder,.vlt-input-group input[type=\"date\"][data-v-28bf1643]::-webkit-input-placeholder,.vlt-input-group input[type=\"password\"][data-v-28bf1643]::-webkit-input-placeholder,.vlt-input-group input[type=\"email\"][data-v-28bf1643]::-webkit-input-placeholder,.vlt-input-group textarea[data-v-28bf1643]::-webkit-input-placeholder{color:#b7b7b7\n}\n.vlt-input-group input[type=\"text\"][data-v-28bf1643]::-moz-placeholder,.vlt-input-group input[type=\"search\"][data-v-28bf1643]::-moz-placeholder,.vlt-input-group input[type=\"date\"][data-v-28bf1643]::-moz-placeholder,.vlt-input-group input[type=\"password\"][data-v-28bf1643]::-moz-placeholder,.vlt-input-group input[type=\"email\"][data-v-28bf1643]::-moz-placeholder,.vlt-input-group textarea[data-v-28bf1643]::-moz-placeholder{color:#b7b7b7\n}\n.vlt-input-group input[type=\"text\"][data-v-28bf1643]:-ms-input-placeholder,.vlt-input-group input[type=\"search\"][data-v-28bf1643]:-ms-input-placeholder,.vlt-input-group input[type=\"date\"][data-v-28bf1643]:-ms-input-placeholder,.vlt-input-group input[type=\"password\"][data-v-28bf1643]:-ms-input-placeholder,.vlt-input-group input[type=\"email\"][data-v-28bf1643]:-ms-input-placeholder,.vlt-input-group textarea[data-v-28bf1643]:-ms-input-placeholder{color:#b7b7b7\n}\n.vlt-input-group input[type=\"text\"][data-v-28bf1643]:-moz-placeholder,.vlt-input-group input[type=\"search\"][data-v-28bf1643]:-moz-placeholder,.vlt-input-group input[type=\"date\"][data-v-28bf1643]:-moz-placeholder,.vlt-input-group input[type=\"password\"][data-v-28bf1643]:-moz-placeholder,.vlt-input-group input[type=\"email\"][data-v-28bf1643]:-moz-placeholder,.vlt-input-group textarea[data-v-28bf1643]:-moz-placeholder{color:#b7b7b7\n}\n.vlt-input-group textarea[data-v-28bf1643]{resize:vertical\n}\n.vlt-input-group.input-ico[data-v-28bf1643]{background-repeat:no-repeat;background-size:18px;background-position:95% 34px\n}\n.vlt-input-group.input-ico input[type=\"text\"][data-v-28bf1643],.vlt-input-group.input-ico input[type=\"password\"][data-v-28bf1643]{padding-right:38px\n}\n.vlt-input[data-v-28bf1643]{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none\n}\n.vlt-input .ico-img[data-v-28bf1643]{position:absolute;top:10px;right:10px\n}\n.vlt-input .ico-img img[data-v-28bf1643]{width:18px\n}\n.vlt-mtrl-group[data-v-28bf1643]{position:relative\n}\n.vlt-mtrl-group label[data-v-28bf1643]{font-size:15px;font-weight:normal;position:absolute;pointer-events:none;left:5px;top:10px;transition:0.2s ease all;-moz-transition:0.2s ease all;-webkit-transition:0.2s ease all\n}\n.vlt-mtrl-group label.error[data-v-28bf1643]{color:#ef5350\n}\n.vlt-mtrl-group .bar[data-v-28bf1643]{position:relative;display:block\n}\n.vlt-mtrl-group .bar[data-v-28bf1643]:before,.vlt-mtrl-group .bar[data-v-28bf1643]:after{content:'';height:1px;width:0;bottom:1px;position:absolute;transition:0.2s ease all;-moz-transition:0.2s ease all;-webkit-transition:0.2s ease all\n}\n.vlt-mtrl-group .bar[data-v-28bf1643]:before{left:50%\n}\n.vlt-mtrl-group .bar[data-v-28bf1643]:after{right:50%\n}\n.vlt-mtrl-group .highlight[data-v-28bf1643]{position:absolute;height:60%;width:auto;top:25%;left:0;pointer-events:none;opacity:0.5\n}\n.vlt-mtrl-group input[data-v-28bf1643]{font-size:15px;padding:8px 8px 8px 5px;display:block;width:100%;border:none;border-bottom:1px solid transparent;background-color:transparent\n}\n.vlt-mtrl-group input:focus ~ label[data-v-28bf1643],.vlt-mtrl-group input:not(:placeholder-shown) ~ label[data-v-28bf1643]{top:-14px;font-size:12px\n}\n.vlt-mtrl-group input:focus ~ label.error[data-v-28bf1643],.vlt-mtrl-group input:not(:placeholder-shown) ~ label.error[data-v-28bf1643]{color:#ef5350\n}\n.vlt-mtrl-group input:focus ~ .bar[data-v-28bf1643]:before,.vlt-mtrl-group input:focus ~ .bar[data-v-28bf1643]:after{width:50%\n}\n.vlt-mtrl-group input:focus ~ .highlight[data-v-28bf1643]{-webkit-animation:inputHighlighter-data-v-28bf1643 0.3s ease;animation:inputHighlighter-data-v-28bf1643 0.3s ease\n}\n@-webkit-keyframes inputHighlighter-data-v-28bf1643{\nfrom{\n}\nto{width:0;background:transparent\n}\n}\n@keyframes inputHighlighter-data-v-28bf1643{\nfrom{\n}\nto{width:0;background:transparent\n}\n}\n.vlt-form-control[data-v-28bf1643]{min-width:200px\n}\n.vlt-form-control[data-v-28bf1643]::-webkit-input-placeholder{opacity:1\n}\n.vlt-form-control[data-v-28bf1643]:-ms-input-placeholder{opacity:1\n}\n.vlt-form-control[data-v-28bf1643]::-ms-input-placeholder{opacity:1\n}\n.vlt-form-control[data-v-28bf1643]::placeholder{opacity:1\n}\n.vlt-input[data-v-28bf1643]{position:relative\n}\n.vlt-input .ico-img[data-v-28bf1643]{position:absolute;top:10px;right:10px\n}\n.vlt-input .ico-img img[data-v-28bf1643]{width:18px\n}\n.grid-title[data-v-28bf1643]{margin-bottom:15px\n}\n.vlt-slct-input[data-v-28bf1643]{border:2px solid #e2e2e2;border-radius:3px;font-size:14px;height:40px;width:100%;background-color:transparent;padding:0px 20px\n}\n.vlt-radio[data-v-28bf1643]{position:relative\n}\n.vlt-radio.inline[data-v-28bf1643]{display:inline-block;margin-right:10px\n}\n.vlt-radio input[data-v-28bf1643]{opacity:0;position:absolute\n}\n.vlt-radio input:checked+label[data-v-28bf1643]::after{width:7px;height:7px;left:4px;top:6px;border-radius:50%\n}\n.vlt-radio label[data-v-28bf1643]{position:relative;padding-left:20px;font-weight:300\n}\n.vlt-radio label[data-v-28bf1643]::before,.vlt-radio label[data-v-28bf1643]::after{position:absolute;content:''\n}\n.vlt-radio label[data-v-28bf1643]::before{width:15px;height:15px;border-radius:50%;left:0;top:2px;border:2px solid #f5f5f5\n}\n.mx-input[data-v-28bf1643]{border-radius:0 !important;-webkit-box-shadow:none !important;box-shadow:none !important\n}\n.mx-input-icon[data-v-28bf1643]{display:none !important\n}\n.vlt-tags li[data-v-28bf1643]{display:inline-block;border-radius:20px;margin-right:10px;text-align:center\n}\n.vlt-tags li .tag-link[data-v-28bf1643],.vlt-tags li a[data-v-28bf1643]{display:block;font-size:13px;text-transform:uppercase;padding:2px 10px;min-width:90px\n}\n.vlt-tags li[data-v-28bf1643]:last-child{margin-right:0\n}\n.vlt-light .vlt-tags li .tag-link[data-v-28bf1643],.vlt-light .vlt-tags li a[data-v-28bf1643]{color:#f5f5f5\n}\n.vlt-dark .vlt-tags li .tag-link[data-v-28bf1643],.vlt-dark .vlt-tags li a[data-v-28bf1643]{color:#222\n}\n.popup-animate-enter-active[data-v-28bf1643],.popup-animate-leave-active[data-v-28bf1643]{-webkit-transition:opacity .5s;transition:opacity .5s\n}\n.popup-animate-enter[data-v-28bf1643],.popup-animate-leave-to[data-v-28bf1643]{opacity:0\n}\n.mx-input-append[data-v-28bf1643]{display:none !important\n}\ninput[type=text][data-v-28bf1643]::-ms-clear{display:none;width:0;height:0\n}\ninput[type=text][data-v-28bf1643]::-ms-reveal{display:none;width:0;height:0\n}\ninput[type=\"search\"][data-v-28bf1643]::-webkit-search-decoration,input[type=\"search\"][data-v-28bf1643]::-webkit-search-cancel-button,input[type=\"search\"][data-v-28bf1643]::-webkit-search-results-button,input[type=\"search\"][data-v-28bf1643]::-webkit-search-results-decoration{display:none\n}\ninput[type=text][data-v-28bf1643]::-ms-clear{display:none;width:0;height:0\n}\ninput[type=text][data-v-28bf1643]::-ms-reveal{display:none;width:0;height:0\n}\ninput[type=\"search\"][data-v-28bf1643]::-webkit-search-decoration,input[type=\"search\"][data-v-28bf1643]::-webkit-search-cancel-button,input[type=\"search\"][data-v-28bf1643]::-webkit-search-results-button,input[type=\"search\"][data-v-28bf1643]::-webkit-search-results-decoration{display:none\n}\nbutton[data-v-28bf1643]:disabled:hover{cursor:not-allowed\n}\n.button-hover[data-v-28bf1643]{-webkit-transition:all 0.4s cubic-bezier(0.47, 0, 0.75, 0.72);transition:all 0.4s cubic-bezier(0.47, 0, 0.75, 0.72);cursor:pointer\n}\n.button-hover[data-v-28bf1643]:hover{color:white !important;background-color:#5a5a5a !important\n}\n.button-click-hover[data-v-28bf1643]{-webkit-transition-duration:0.4s;transition-duration:0.4s\n}\n.button-click-hover[data-v-28bf1643]:hover{background:-webkit-gradient(linear, left top, right top, from(#5a5a5a), to(#222)) !important;background:linear-gradient(to right, #5a5a5a, #222) !important;-webkit-transform:translateY(1px);transform:translateY(1px)\n}\n.player-container[data-v-28bf1643]{margin:0 auto;width:950px\n}\n.mx-calendar-content .cell.actived[data-v-28bf1643]{background-color:#222\n}\n.error-message[data-v-28bf1643]{color:red\n}\n.formError[data-v-28bf1643]{border-bottom:1px solid red !important\n}\n.vlt-share-contain[data-v-28bf1643]{position:relative;z-index:89\n}\n.vlt-share-contain .share-popup[data-v-28bf1643]{position:absolute;background-color:#e6e6e6;padding:2px 8px;width:210px;border-radius:40px;top:0px;left:100%;-webkit-transition:0.5s;transition:0.5s\n}\n.vlt-share-contain .share-popup ul[data-v-28bf1643]{text-align:center\n}\n.vlt-share-contain .share-popup ul li[data-v-28bf1643]{display:inline-block;margin-right:15px;cursor:pointer\n}\n.vlt-share-contain .share-popup ul li img[data-v-28bf1643]{width:40px;padding:8px;vertical-align:middle\n}\n.vlt-share-contain .share-popup ul li[data-v-28bf1643]:last-child{margin-right:0\n}\n.vlt-share-contain .vlt-btn-ico[data-v-28bf1643]{cursor:pointer\n}\n.share-overlay[data-v-28bf1643]{position:fixed;top:0;left:0;width:100%;height:100%;z-index:88\n}\n.share-icon[data-v-28bf1643]{padding-top:0\n}\n.share-icon img[data-v-28bf1643]{width:30px;margin-bottom:0\n}\n@media only screen and (max-width: 576px){\n.share-icon[data-v-28bf1643]{padding-top:0\n}\n.vlt-share-contain .share-popup[data-v-28bf1643]{width:35px;margin-left:10px;border-radius:20px;position:absolute;background-color:#e6e6e6;padding:5px;top:0px;left:100%;-webkit-transition:0.5s;transition:0.5s;text-align:center\n}\n.vlt-share-contain .share-popup ul li[data-v-28bf1643]{margin-right:7px;display:block\n}\n.vlt-share-contain .share-popup ul li img[data-v-28bf1643]{width:25px;padding:5px\n}\n.vlt-share-contain .share-popup ul li[data-v-28bf1643]:last-child{margin-right:0\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 768px){\n.share-icon[data-v-28bf1643]{padding-top:0\n}\n.vlt-share-contain .share-popup[data-v-28bf1643]{width:35px;margin-left:10px;border-radius:20px;position:absolute;background-color:#e6e6e6;padding:5px;top:0px;left:50%;-webkit-transition:0.5s;transition:0.5s;text-align:center\n}\n.vlt-share-contain .share-popup ul li[data-v-28bf1643]{margin-right:7px;display:block\n}\n.vlt-share-contain .share-popup ul li img[data-v-28bf1643]{width:25px;padding:5px\n}\n.vlt-share-contain .share-popup ul li[data-v-28bf1643]:last-child{margin-right:0\n}\n}\n.share-tag[data-v-28bf1643]{color:#ffffff;font-family:\"ProximanovaRegular\";font-size:18px;font-weight:bold;line-height:24px;text-align:center\n}\n@media screen and (min-width: 1900px){\n.share-icon[data-v-28bf1643]{padding-top:0\n}\n.share-icon img[data-v-28bf1643]{width:35px\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snackbar v0.1.14
 * http://polonel.com/Snackbar
 *
 * Copyright 2018 Chris Brame and other contributors
 * Released under the MIT license
 * https://github.com/polonel/Snackbar/blob/master/LICENSE
 */

(function(root, factory) {
    'use strict';

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
            return (root.Snackbar = factory());
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = root.Snackbar = factory();
    } else {
        root.Snackbar = factory();
    }
})(this, function() {
    var Snackbar = {};

    Snackbar.current = null;
    var $defaults = {
        text: 'Default Text',
        textColor: '#FFFFFF',
        width: 'auto',
        showAction: true,
        actionText: 'Dismiss',
        actionTextAria: 'Dismiss, Description for Screen Readers',
        alertScreenReader: false,
        actionTextColor: '#4CAF50',
        showSecondButton: false,
        secondButtonText: '',
        secondButtonAria: 'Description for Screen Readers',
        secondButtonTextColor: '#4CAF50',
        backgroundColor: '#323232',
        pos: 'bottom-left',
        duration: 5000,
        customClass: '',
        onActionClick: function(element) {
            element.style.opacity = 0;
        },
        onSecondButtonClick: function(element) {},
        onClose: function(element) {}
    };

    Snackbar.show = function($options) {
        var options = Extend(true, $defaults, $options);

        if (Snackbar.current) {
            Snackbar.current.style.opacity = 0;
            setTimeout(
                function() {
                    var $parent = this.parentElement;
                    if ($parent)
                    // possible null if too many/fast Snackbars
                        $parent.removeChild(this);
                }.bind(Snackbar.current),
                500
            );
        }

        Snackbar.snackbar = document.createElement('div');
        Snackbar.snackbar.className = 'snackbar-container ' + options.customClass;
        Snackbar.snackbar.style.width = options.width;
        var $p = document.createElement('p');
        $p.style.margin = 0;
        $p.style.padding = 0;
        $p.style.color = options.textColor;
        $p.style.fontSize = '14px';
        $p.style.fontWeight = 300;
        $p.style.lineHeight = '1em';
        $p.innerHTML = options.text;
        Snackbar.snackbar.appendChild($p);
        Snackbar.snackbar.style.background = options.backgroundColor;

        if (options.showSecondButton) {
            var secondButton = document.createElement('button');
            secondButton.className = 'action';
            secondButton.innerHTML = options.secondButtonText;
            secondButton.setAttribute('aria-label', options.secondButtonAria);
            secondButton.style.color = options.secondButtonTextColor;
            secondButton.addEventListener('click', function() {
                options.onSecondButtonClick(Snackbar.snackbar);
            });
            Snackbar.snackbar.appendChild(secondButton);
        }

        if (options.showAction) {
            var actionButton = document.createElement('button');
            actionButton.className = 'action';
            actionButton.innerHTML = options.actionText;
            actionButton.setAttribute('aria-label', options.actionTextAria);
            actionButton.style.color = options.actionTextColor;
            actionButton.addEventListener('click', function() {
                options.onActionClick(Snackbar.snackbar);
            });
            Snackbar.snackbar.appendChild(actionButton);
        }

        if (options.duration) {
            setTimeout(
                function() {
                    if (Snackbar.current === this) {
                        Snackbar.current.style.opacity = 0;
                        // When natural remove event occurs let's move the snackbar to its origins
                        Snackbar.current.style.top = '-100px';
                        Snackbar.current.style.bottom = '-100px';
                    }
                }.bind(Snackbar.snackbar),
                options.duration
            );
        }

        if (options.alertScreenReader) {
           Snackbar.snackbar.setAttribute('role', 'alert');
        }

        Snackbar.snackbar.addEventListener(
            'transitionend',
            function(event, elapsed) {
                if (event.propertyName === 'opacity' && this.style.opacity === '0') {
                    if (typeof(options.onClose) === 'function')
                        options.onClose(this);

                    this.parentElement.removeChild(this);
                    if (Snackbar.current === this) {
                        Snackbar.current = null;
                    }
                }
            }.bind(Snackbar.snackbar)
        );

        Snackbar.current = Snackbar.snackbar;

        document.body.appendChild(Snackbar.snackbar);
        var $bottom = getComputedStyle(Snackbar.snackbar).bottom;
        var $top = getComputedStyle(Snackbar.snackbar).top;
        Snackbar.snackbar.style.opacity = 1;
        Snackbar.snackbar.className =
            'snackbar-container ' + options.customClass + ' snackbar-pos ' + options.pos;
    };

    Snackbar.close = function() {
        if (Snackbar.current) {
            Snackbar.current.style.opacity = 0;
        }
    };

    // Pure JS Extend
    // http://gomakethings.com/vanilla-javascript-version-of-jquery-extend/
    var Extend = function() {
        var extended = {};
        var deep = false;
        var i = 0;
        var length = arguments.length;

        if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
            deep = arguments[0];
            i++;
        }

        var merge = function(obj) {
            for (var prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                        extended[prop] = Extend(true, extended[prop], obj[prop]);
                    } else {
                        extended[prop] = obj[prop];
                    }
                }
            }
        };

        for (; i < length; i++) {
            var obj = arguments[i];
            merge(obj);
        }

        return extended;
    };

    return Snackbar;
});


/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(469);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("49fed8ee", content, true, {});

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".snackbar-container{transition:all .5s ease;transition-property:top,right,bottom,left,opacity;font-family:Roboto,sans-serif;font-size:14px;min-height:14px;background-color:#070b0e;position:fixed;display:flex;justify-content:space-between;align-items:center;color:#fff;line-height:22px;padding:18px 24px;bottom:-100px;top:-100px;opacity:0;z-index:9999}.snackbar-container .action{background:inherit;display:inline-block;border:none;font-size:inherit;text-transform:uppercase;color:#4caf50;margin:0 0 0 24px;padding:0;min-width:min-content;cursor:pointer}@media (min-width:640px){.snackbar-container{min-width:288px;max-width:568px;display:inline-flex;border-radius:2px;margin:24px}}@media (max-width:640px){.snackbar-container{left:0;right:0;width:100%}}.snackbar-pos.bottom-center{top:auto!important;bottom:0;left:50%;transform:translate(-50%)}.snackbar-pos.bottom-left{top:auto!important;bottom:0;left:0}.snackbar-pos.bottom-right{top:auto!important;bottom:0;right:0}.snackbar-pos.top-left{bottom:auto!important;top:0;left:0}.snackbar-pos.top-center{bottom:auto!important;top:0;left:50%;transform:translate(-50%)}.snackbar-pos.top-right{bottom:auto!important;top:0;right:0}@media (max-width:640px){.snackbar-pos.bottom-center,.snackbar-pos.top-center{left:0;transform:none}}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/node_modules/node-snackbar/dist/snackbar.css"],"names":[],"mappings":"AAAA,oBACE,wBAA2B,AAC3B,kDAAuD,AACvD,8BAAgC,AAChC,eAAgB,AAChB,gBAAiB,AACjB,yBAA0B,AAC1B,eAAgB,AAChB,aAAc,AACd,8BAA+B,AAC/B,mBAAoB,AACpB,WAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,cAAe,AACf,WAAY,AACZ,UAAW,AACX,YAAc,CAAE,AAChB,4BACE,mBAAoB,AACpB,qBAAsB,AACtB,YAAa,AACb,kBAAmB,AACnB,yBAA0B,AAC1B,cAAe,AACf,kBAAmB,AACnB,UAAW,AACX,sBAAuB,AACvB,cAAgB,CAAE,AAEtB,yBACE,oBACE,gBAAiB,AACjB,gBAAiB,AACjB,oBAAqB,AACrB,kBAAmB,AACnB,WAAa,CAAE,CAAE,AAErB,yBACE,oBACE,OAAQ,AACR,QAAS,AACT,UAAY,CAAE,CAAE,AAEpB,4BACE,mBAAqB,AACrB,SAAU,AACV,SAAU,AACV,yBAA8B,CAAE,AAElC,0BACE,mBAAqB,AACrB,SAAU,AACV,MAAQ,CAAE,AAEZ,2BACE,mBAAqB,AACrB,SAAU,AACV,OAAS,CAAE,AAEb,uBACE,sBAAwB,AACxB,MAAO,AACP,MAAQ,CAAE,AAEZ,yBACE,sBAAwB,AACxB,MAAO,AACP,SAAU,AACV,yBAA8B,CAAE,AAElC,wBACE,sBAAwB,AACxB,MAAO,AACP,OAAS,CAAE,AAEb,yBACE,qDACE,OAAQ,AACR,cAAgB,CAAE,CAAE","file":"snackbar.css","sourcesContent":[".snackbar-container {\n  transition: all 500ms ease;\n  transition-property: top, right, bottom, left, opacity;\n  font-family: Roboto, sans-serif;\n  font-size: 14px;\n  min-height: 14px;\n  background-color: #070b0e;\n  position: fixed;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: white;\n  line-height: 22px;\n  padding: 18px 24px;\n  bottom: -100px;\n  top: -100px;\n  opacity: 0;\n  z-index: 9999; }\n  .snackbar-container .action {\n    background: inherit;\n    display: inline-block;\n    border: none;\n    font-size: inherit;\n    text-transform: uppercase;\n    color: #4caf50;\n    margin: 0 0 0 24px;\n    padding: 0;\n    min-width: min-content;\n    cursor: pointer; }\n\n@media (min-width: 640px) {\n  .snackbar-container {\n    min-width: 288px;\n    max-width: 568px;\n    display: inline-flex;\n    border-radius: 2px;\n    margin: 24px; } }\n\n@media (max-width: 640px) {\n  .snackbar-container {\n    left: 0;\n    right: 0;\n    width: 100%; } }\n\n.snackbar-pos.bottom-center {\n  top: auto !important;\n  bottom: 0;\n  left: 50%;\n  transform: translate(-50%, 0); }\n\n.snackbar-pos.bottom-left {\n  top: auto !important;\n  bottom: 0;\n  left: 0; }\n\n.snackbar-pos.bottom-right {\n  top: auto !important;\n  bottom: 0;\n  right: 0; }\n\n.snackbar-pos.top-left {\n  bottom: auto !important;\n  top: 0;\n  left: 0; }\n\n.snackbar-pos.top-center {\n  bottom: auto !important;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0); }\n\n.snackbar-pos.top-right {\n  bottom: auto !important;\n  top: 0;\n  right: 0; }\n\n@media (max-width: 640px) {\n  .snackbar-pos.bottom-center, .snackbar-pos.top-center {\n    left: 0;\n    transform: none; } }\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * clipboard.js v2.0.4
 * https://zenorocha.github.io/clipboard.js
 * 
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ClipboardJS"] = factory();
	else
		root["ClipboardJS"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboardAction = __webpack_require__(1);

var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

var _tinyEmitter = __webpack_require__(3);

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

var _goodListener = __webpack_require__(4);

var _goodListener2 = _interopRequireDefault(_goodListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */
var Clipboard = function (_Emitter) {
    _inherits(Clipboard, _Emitter);

    /**
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     * @param {Object} options
     */
    function Clipboard(trigger, options) {
        _classCallCheck(this, Clipboard);

        var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

        _this.resolveOptions(options);
        _this.listenClick(trigger);
        return _this;
    }

    /**
     * Defines if attributes would be resolved using internal setter functions
     * or custom functions that were passed in the constructor.
     * @param {Object} options
     */


    _createClass(Clipboard, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
            this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
            this.text = typeof options.text === 'function' ? options.text : this.defaultText;
            this.container = _typeof(options.container) === 'object' ? options.container : document.body;
        }

        /**
         * Adds a click event listener to the passed trigger.
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         */

    }, {
        key: 'listenClick',
        value: function listenClick(trigger) {
            var _this2 = this;

            this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                return _this2.onClick(e);
            });
        }

        /**
         * Defines a new `ClipboardAction` on each click event.
         * @param {Event} e
         */

    }, {
        key: 'onClick',
        value: function onClick(e) {
            var trigger = e.delegateTarget || e.currentTarget;

            if (this.clipboardAction) {
                this.clipboardAction = null;
            }

            this.clipboardAction = new _clipboardAction2.default({
                action: this.action(trigger),
                target: this.target(trigger),
                text: this.text(trigger),
                container: this.container,
                trigger: trigger,
                emitter: this
            });
        }

        /**
         * Default `action` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultAction',
        value: function defaultAction(trigger) {
            return getAttributeValue('action', trigger);
        }

        /**
         * Default `target` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultTarget',
        value: function defaultTarget(trigger) {
            var selector = getAttributeValue('target', trigger);

            if (selector) {
                return document.querySelector(selector);
            }
        }

        /**
         * Returns the support of the given action, or all actions if no action is
         * given.
         * @param {String} [action]
         */

    }, {
        key: 'defaultText',


        /**
         * Default `text` lookup function.
         * @param {Element} trigger
         */
        value: function defaultText(trigger) {
            return getAttributeValue('text', trigger);
        }

        /**
         * Destroy lifecycle.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            this.listener.destroy();

            if (this.clipboardAction) {
                this.clipboardAction.destroy();
                this.clipboardAction = null;
            }
        }
    }], [{
        key: 'isSupported',
        value: function isSupported() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

            var actions = typeof action === 'string' ? [action] : action;
            var support = !!document.queryCommandSupported;

            actions.forEach(function (action) {
                support = support && !!document.queryCommandSupported(action);
            });

            return support;
        }
    }]);

    return Clipboard;
}(_tinyEmitter2.default);

/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */


function getAttributeValue(suffix, element) {
    var attribute = 'data-clipboard-' + suffix;

    if (!element.hasAttribute(attribute)) {
        return;
    }

    return element.getAttribute(attribute);
}

module.exports = Clipboard;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _select = __webpack_require__(2);

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */
var ClipboardAction = function () {
    /**
     * @param {Object} options
     */
    function ClipboardAction(options) {
        _classCallCheck(this, ClipboardAction);

        this.resolveOptions(options);
        this.initSelection();
    }

    /**
     * Defines base properties passed from constructor.
     * @param {Object} options
     */


    _createClass(ClipboardAction, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = options.action;
            this.container = options.container;
            this.emitter = options.emitter;
            this.target = options.target;
            this.text = options.text;
            this.trigger = options.trigger;

            this.selectedText = '';
        }

        /**
         * Decides which selection strategy is going to be applied based
         * on the existence of `text` and `target` properties.
         */

    }, {
        key: 'initSelection',
        value: function initSelection() {
            if (this.text) {
                this.selectFake();
            } else if (this.target) {
                this.selectTarget();
            }
        }

        /**
         * Creates a fake textarea element, sets its value from `text` property,
         * and makes a selection on it.
         */

    }, {
        key: 'selectFake',
        value: function selectFake() {
            var _this = this;

            var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

            this.removeFake();

            this.fakeHandlerCallback = function () {
                return _this.removeFake();
            };
            this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

            this.fakeElem = document.createElement('textarea');
            // Prevent zooming on iOS
            this.fakeElem.style.fontSize = '12pt';
            // Reset box model
            this.fakeElem.style.border = '0';
            this.fakeElem.style.padding = '0';
            this.fakeElem.style.margin = '0';
            // Move element out of screen horizontally
            this.fakeElem.style.position = 'absolute';
            this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
            // Move element to the same position vertically
            var yPosition = window.pageYOffset || document.documentElement.scrollTop;
            this.fakeElem.style.top = yPosition + 'px';

            this.fakeElem.setAttribute('readonly', '');
            this.fakeElem.value = this.text;

            this.container.appendChild(this.fakeElem);

            this.selectedText = (0, _select2.default)(this.fakeElem);
            this.copyText();
        }

        /**
         * Only removes the fake element after another click event, that way
         * a user can hit `Ctrl+C` to copy because selection still exists.
         */

    }, {
        key: 'removeFake',
        value: function removeFake() {
            if (this.fakeHandler) {
                this.container.removeEventListener('click', this.fakeHandlerCallback);
                this.fakeHandler = null;
                this.fakeHandlerCallback = null;
            }

            if (this.fakeElem) {
                this.container.removeChild(this.fakeElem);
                this.fakeElem = null;
            }
        }

        /**
         * Selects the content from element passed on `target` property.
         */

    }, {
        key: 'selectTarget',
        value: function selectTarget() {
            this.selectedText = (0, _select2.default)(this.target);
            this.copyText();
        }

        /**
         * Executes the copy operation based on the current selection.
         */

    }, {
        key: 'copyText',
        value: function copyText() {
            var succeeded = void 0;

            try {
                succeeded = document.execCommand(this.action);
            } catch (err) {
                succeeded = false;
            }

            this.handleResult(succeeded);
        }

        /**
         * Fires an event based on the copy operation result.
         * @param {Boolean} succeeded
         */

    }, {
        key: 'handleResult',
        value: function handleResult(succeeded) {
            this.emitter.emit(succeeded ? 'success' : 'error', {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
            });
        }

        /**
         * Moves focus away from `target` and back to the trigger, removes current selection.
         */

    }, {
        key: 'clearSelection',
        value: function clearSelection() {
            if (this.trigger) {
                this.trigger.focus();
            }

            window.getSelection().removeAllRanges();
        }

        /**
         * Sets the `action` to be performed which can be either 'copy' or 'cut'.
         * @param {String} action
         */

    }, {
        key: 'destroy',


        /**
         * Destroy lifecycle.
         */
        value: function destroy() {
            this.removeFake();
        }
    }, {
        key: 'action',
        set: function set() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

            this._action = action;

            if (this._action !== 'copy' && this._action !== 'cut') {
                throw new Error('Invalid "action" value, use either "copy" or "cut"');
            }
        }

        /**
         * Gets the `action` property.
         * @return {String}
         */
        ,
        get: function get() {
            return this._action;
        }

        /**
         * Sets the `target` property using an element
         * that will be have its content copied.
         * @param {Element} target
         */

    }, {
        key: 'target',
        set: function set(target) {
            if (target !== undefined) {
                if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                    if (this.action === 'copy' && target.hasAttribute('disabled')) {
                        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    }

                    if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                    }

                    this._target = target;
                } else {
                    throw new Error('Invalid "target" value, use a valid Element');
                }
            }
        }

        /**
         * Gets the `target` property.
         * @return {String|HTMLElement}
         */
        ,
        get: function get() {
            return this._target;
        }
    }]);

    return ClipboardAction;
}();

module.exports = ClipboardAction;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(5);
var delegate = __webpack_require__(6);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(7);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ })
/******/ ]);
});

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAABQVBMVEVHcEz///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+uCSUUAAAAanRSTlMAEwzX7tTy/A37DvaXTbMXwe/0aNNXGUf6T2YEatUbTi/YGBbzlgqV4vBv1hyiIYhpMLa1Z7RCTOFQ0laZRutL0bL1k1WYQGQCRepK2v7AXuSCSZHZGr/jLhSACY+U3EES27H5sPh3gUiQ2kvNMQAAApNJREFUaN7tmVdXGkEcxRdY3F0BkS6IEaRpTARrLGmWWBJrTCwppmqS+f4fIJAtccbZ4WHunJyTs/dtfLh/nL3M/PaiaYECBULoXnkukk5H5jpvldhftr8RR9bjCbz/6ylyS6kC2n/BIJSMEta/YBFGxjOk/8QUuaNUEjjgBeGoBcynxRswkocNKLue2UQ4nIi6qwxswLzrb/ZWpjthCDbgjeP4yF6OO8sIbMCA4xi2l4POcgA+wFQ1oOo4JuxlEb1FOd1xjP75FwbHsA95dvhv9KPjplkcg8Y0FDeIjxBftNHSU+KrTXn/pay/PdFrsvYPHgrsifFK0r55EhP5Wzuy0ZykP2985Zjanye4aPY0XOnm6deGl5+PNWg0J3P232uZr/vp+vTiQh4azVg7DL3et5/TuzM0A7Vnoxn5CbVvvqOjqd8fBbDm1Xon6RPNkBzrxD1WiJ12rSpsNGeRrHm84hNNGGvSip004ayJjSaPNT1llxSxJiaaAtZERFPMmvLR7MOaeg51JPiwZjVgzX6siduieT5r4h5ymc+a9uWu7qUO+EXTGoqPCi2ZEhx2q4DDTttTfFxrWkl84fxoSk8oULt0zl6Zy2vyz6E14rptfPh899I/lI9sPrM4XU/vf8/U+NjSCGlgvb+pK4gsg44HNDrCqzPV8NvV7tFLpfjeewFpMJHdcnLXWf8C6k0rh/Q+nV10x5566G015Pu6tWU6sq3iObg3Zd8VCL43ZSOroDf9tCqYAOlN2cgq6E1DLaV1Tk8XZ7fIXk1vuqWr7k2rQW/6r3tTP5bFPeSywt5UwLLAHyj4LLuJ8+eyrHxvKmZZ6d60D8tK96Z9WFa2N+Xpsn3t5UfFj6Uuy8r3poEC/b/6DW4Qk0rYO3fmAAAAAElFTkSuQmCC"

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vlt-share"},[_c('div',{staticClass:"vlt-share-contain"},[_c('button',{staticClass:"vlt-btn-ico primary share-icon",attrs:{"type":"button"},on:{"click":function () { return _vm.togglePopup(_vm.showPopup ? false : true); }}},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":"share icon"}}),_vm._v(" "),_c('p',{staticClass:"share-tag",style:({
          color: _vm.color === 'BLACK' ? '#000000' : 'FFFFFF'
        })},[_vm._v("\n        Share\n      ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopup),expression:"showPopup"}],staticClass:"share-popup"},[_c('div',{staticClass:"share-box"},[_c('ul',[_c('li',{on:{"click":_vm.shareFbCB}},[_c('img',{staticClass:"share-ico",attrs:{"src":__webpack_require__(474),"alt":"fb icon"}})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":_vm.twitterShareUrl,"id":"twitter-button"},on:{"click":function($event){return _vm.shareTwCB()}}},[_c('img',{staticClass:"share-ico",attrs:{"src":__webpack_require__(475),"alt":"gp icon"}})])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"custom-link",attrs:{"data-clipboard-text":_vm.link,"target":"_blank"},on:{"click":function($event){return _vm.shareCount('OTHERS')}}},[_c('img',{staticClass:"share-ico",attrs:{"src":__webpack_require__(476),"alt":"tw icon"}})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopup),expression:"showPopup"}],staticClass:"share-overlay",on:{"click":function () { return _vm.togglePopup(false); }}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADdgAAA3YBfdWCzAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAHNSURBVGiB7ZYxb9NAGIafO+VUIjEyBfEHCgNC7GRmYAfmOFL+QRFFQZQI5kiJZCExWGXJxE9AXav+gaoCqWoXhrRSq0tJdB8LAwPESS/2XSo/qz+/fh+ffbYC6HQ6t2ez2RbwHGgAG8TJFXAqIruTyeRDlmWX6k/5b8Cj0O2WZN9a29TT6fQ161ce4HG9Xn+llVIvQjfx4KUG7oZu4cE9DejQLTzQ61weWO+7D0Ct5OsdK6U+O+f2ROTIGHM2HA7H/xpMkkQWCSxLwAHvxuNxbzQa/VplcFkCb9I0fV9EcBnvwFGj0fhYVHgZAp+63e6sqPDCBbTWe0Xml/EOHOYNtNvtp8C2iDwEbi0TXriAMeZ83vFWq/VMRL5eN7/wR6jf71/NO66UeuuTH8OX+IHPyTEIeD3GMQh4UQmERi3615dHmqZqFTl/kyTJHeDnvJmoV0BrnbtDRS3gnLufNxO1gFJqM28magERWe8VAHJXYGW70P/I2518rx/7CuRSCYSmEghNJRCaSiA0lUBoKoHQ3AgBF7qEB04DJ6FbeHCsReRL6BYe7GpjzA5wELrJNdi31vb0YDC4qNVqT4Ae8CNwqUX4LiI71tpmlmWXvwFCan5dnmRyfQAAAABJRU5ErkJggg=="

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// static/js/24.1630b738f506a5e8b777.js